import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '../../../base.service';
import { BehaviorSubject } from 'rxjs';


export class UserModel {
  id!: number;
  userType_Id!: number;
  partner_Id!: number;
  createdBy!: number;
  userName!: string;
  userDisplayName!: string;
  firstName!: string;
  lastName!: string;
  aspUserID!: string;
  emailAddress!: string;
  mobilePhoneNumber!: string;
  address!: string;
  isEmailVerified!: boolean;
  isMobilePhoneVerified!: boolean;
  isActive!: boolean;
  picture!: null;
  createdOnUTC!: string;
  updatedOnUTC!: string;
  reserved1!: string;
  file!: File;
  approvedFrom!: number
  password!: string; 
  roles!: any;
  O_Origin!: string;
}

export class BillingInfoModel {
  id!: number;
  user_Id!: number;
  partner_Id!: number;
  legalName!: string;
  streetAddr!: string;
  state!: string;
  city!: string;
  zipCode!: string;
  country: string = '';
  emailAddress!: string;
  phoneNo!: string;
}


export class UserExtraInfoModel {
  id!: string;
  users_Id!: string;
  partner_Id!: number;
  addr_Street!: string;
  addr_City!: string;
  addr_State!: string;
  addr_ZipCode!: string;
  addr_Country: string = '';
  businessType: string = '';
  companyName!: string;
  industry: string = '';
  url!: string;
  phoneNo!: string;
  contactPersonName!: string;
  contactPersonPhone!: string;
  contactPersonEmail!: string;
}

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  constructor(private http: HttpClient, private BaseService: BaseService) {}


  private storageUserKey = 'UserData';
  savedUserData = localStorage.getItem(this.storageUserKey);
  private selectedUserDatadataSource = new BehaviorSubject<any>(this.savedUserData ? JSON.parse(this.savedUserData) : null);
  selectedUserData = this.selectedUserDatadataSource.asObservable();
  selectedUserDataUpdate(data: any) {
    console.log("🚀 > UsersService > selectedUserDataUpdate > data:", data);
    this.selectedUserDatadataSource.next(data);
    localStorage.setItem(this.storageUserKey, JSON.stringify(data));
  }

  private storageClientKey = 'ClientData';
  savedClientData = localStorage.getItem(this.storageClientKey);
  private selectedClientDatadataSource = new BehaviorSubject<any>(this.savedClientData ? JSON.parse(this.savedClientData) : null);
  selectedClientData = this.selectedClientDatadataSource.asObservable();
  selectedClientDataUpdate(data: any) {
    console.log("🚀 > ClientsService > selectedClientDataUpdate > data:", data);
    this.selectedClientDatadataSource.next(data);
    localStorage.setItem(this.storageClientKey, JSON.stringify(data));
  }


  private storagePartnerKey = 'PartnerData';
  savedPartnerData = localStorage.getItem(this.storagePartnerKey);
  private selectedPartnerDatadataSource = new BehaviorSubject<any>(this.savedPartnerData ? JSON.parse(this.savedPartnerData) : null);
  selectedPartnerData = this.selectedPartnerDatadataSource.asObservable();
  selectedPartnerDataUpdate(data: any) {
    console.log("🚀 > PartnersService > selectedPartnerDataUpdate > data:", data);
    this.selectedPartnerDatadataSource.next(data);
    localStorage.setItem(this.storagePartnerKey, JSON.stringify(data));
  }






  UserData : UserModel = new UserModel();
  UserExtraInfoData : UserExtraInfoModel = new UserExtraInfoModel();
  BusinessInfoData: BillingInfoModel = new BillingInfoModel();



  private getHeaders() {
    const token = localStorage.getItem('token');
    return new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
  }

  public generateRandomPassword(length: number = 8): string {
    const upperCaseChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const lowerCaseChars = 'abcdefghijklmnopqrstuvwxyz';
    const numberChars = '0123456789';
    const specialChars = '@$!%*^#?&.(=)+-';
    const allChars = upperCaseChars + lowerCaseChars + numberChars + specialChars;

    let password = '';
    password += upperCaseChars[Math.floor(Math.random() * upperCaseChars.length)];
    password += lowerCaseChars[Math.floor(Math.random() * lowerCaseChars.length)];
    password += numberChars[Math.floor(Math.random() * numberChars.length)];
    password += specialChars[Math.floor(Math.random() * specialChars.length)];

    for (let i = password.length; i < length; i++) {
      password += allChars[Math.floor(Math.random() * allChars.length)];
    }

    return password.split('').sort(() => 0.5 - Math.random()).join('');
  }

  getUsers() {
    const headers = this.getHeaders();
    return this.http.get(this.BaseService.BASEURL + '/api/MS/Users/GetAll', {
      headers,
    });
  }

  getByIdUser(id: any) {
    const headers = this.getHeaders();
    return this.http.get(this.BaseService.BASEURL + '/api/MS/Users/GetByID/' + id, {
      headers,
    });
  }

  getAllByUserTypeAndPartnerID(body:any){
    const headers = this.getHeaders();
    return this.http.post(this.BaseService.BASEURL + '/api/MS/Users/GetAllByUserTypeAndPartnerID',body, {
      headers,
    });
  }

  addUser(UserData: any) {
    const headers = this.getHeaders();
    return this.http.post(this.BaseService.BASEURL + '/api/MS/Users/Add', UserData, {
      headers,
    });
  }

  editUser(UserData: any) {
    const headers = this.getHeaders();
    return this.http.post(this.BaseService.BASEURL + '/api/MS/Users/Edit', UserData, {
      headers,
    });
  }

  deleteUser(id: string) {
    const headers = this.getHeaders();
    return this.http.get(this.BaseService.BASEURL + '/api/MS/Users/Delete/' + id, {
      headers,
    });
  }

  getRolesByuserId(id: any) {
    const headers = this.getHeaders();
    return this.http.get(this.BaseService.BASEURL + '/api/MS/UserRoles/GetUserRolesByUserID/' + id, {
      headers,
    });
  }

  AssignRolesToUser(requestData: any) {
    const headers = this.getHeaders();
    return this.http.post(this.BaseService.BASEURL + '/api/MS/UserRoles/AssignRolesToUser', requestData, {
      headers,
    });
  }

  getAllLicenses() {
    const headers = this.getHeaders();
    return this.http.get(this.BaseService.BASEURL + '/api/MS/License/GetAll', {
      headers,
    });
  }

  getAllLicensesByUserID(id: any) {
    const headers = this.getHeaders();
    return this.http.get(this.BaseService.BASEURL + '/api/License/Operations/GetAllByUserID/' + id, {
      headers,
    });
  }

  getAllLicensesByPersonID(body: any) {
    const headers = this.getHeaders();
    return this.http.post(this.BaseService.BASEURL + '/api/License/GetAllByPerson' , body, {
      headers,
    });
  }

  getLicenseCountByLoginID(body: any){
    const headers = this.getHeaders();
    return this.http.post(this.BaseService.BASEURL + '/api/License/GetCounter' , body, {
      headers,
    });
  }

  getAllLicensesByPartnerID(id: any) {
    const headers = this.getHeaders();
    return this.http.get(this.BaseService.BASEURL + '/api/License/Operations/GetAllByPartner/' + id, {
      headers,
    });
  }

  //UserExtraInfo

  getUserExtraInfo() {
    const headers = this.getHeaders();
    return this.http.get(this.BaseService.BASEURL + '/api/MS/UserExtraInfo/GetAll', {
      headers,
    });
  }

  GetByUserAndPartnerID(Data: any) {
    const headers = this.getHeaders();
    return this.http.post(this.BaseService.BASEURL + '/api/MS/UserBillingAddress/GetByUserAndPartnerID', Data, {
      headers,
    });
  }

  getUserExtraInfoByUserId(id: any) {
    const headers = this.getHeaders();
    return this.http.get(this.BaseService.BASEURL + '/api/MS/UserExtraInfo/GetByUserID/' + id, {
      headers
    });
  }

  addUserExtraInfo(UserExtraInfoData: any) {
    const headers = this.getHeaders();
    return this.http.post(this.BaseService.BASEURL + '/api/MS/UserExtraInfo/Add', UserExtraInfoData, {
      headers,
    });
  }

  editUserExtraInfo(UserExtraInfoData: any) {
    const headers = this.getHeaders();
    return this.http.post(this.BaseService.BASEURL + '/api/MS/UserExtraInfo/Edit', UserExtraInfoData, {
      headers,
    });
  }

  deleteUserExtraInfo(id: string) {
    const headers = this.getHeaders();
    return this.http.get(this.BaseService.BASEURL + '/api/MS/UserExtraInfo/Delete/' + id, {
      headers,
    });
  }


  getPackagesByPartnerid(id: any) {
    const headers = this.getHeaders();
    return this.http.get(this.BaseService.BASEURL + '/api/MS/AssignedPartnerPackages/GetAssignPackages/' + id, {
      headers,
    });
  }

  AssignPackagesToPartner(requestData: any) {
    const headers = this.getHeaders();
    return this.http.post(this.BaseService.BASEURL + '/api/MS/AssignedPartnerPackages/AssignPackages', requestData, {
      headers,
    });
  }

  CheckUserName(username: string) {
    const headers = this.getHeaders();
    return this.http.get(this.BaseService.BASEURL + '/api/Auth/IsEmailInUse?EmailAddr=' + username, {
      headers,
    });
  }


  //Invoice  /api/Payments/Invoice/GetAll 
  getInvoices() {
    const headers = this.getHeaders();
    return this.http.get(this.BaseService.BASEURL + '/api/Payments/Invoice/GetAll', {
      headers,
    });
  }
  
  getUserBillingInfo(id: any) {
    const headers = this.getHeaders();
    return this.http.get(this.BaseService.BASEURL + '/api/MS/UserBillingAddress/GetByUserID/' + id, {
      headers,
    });
  }

  getUserBilling2Info(id: any, partnerId: any) {
    const body = {
      user_Id: id,
      partner_Id: partnerId
    };
    const headers = this.getHeaders();
    return this.http.post(this.BaseService.BASEURL + '/api/MS/UserBillingAddress/GetByUserAndPartnerID' , body, {
      headers,
    });
  }

  AddOrUpdateUserBillingInfo(data: any) {
    const headers = this.getHeaders();

    console.log(data)
    return this.http.post(this.BaseService.BASEURL + '/api/MS/UserBillingAddress/AddOrUpdate', data, {
      headers,
    });
  }

  
  SetApproval(data: any) {
    const headers = this.getHeaders();
    return this.http.post(this.BaseService.BASEURL + '/api/MS/Users/SetApproval', data, {
      headers,
    });
  }





}
